export const housekeepingDrawer = {
  close: "إغلاق",
  guest: "نزيل",

  cleaning: {
    title: "حالة التنظيف",
    lastCleaned: "نُظّفت {date}",
    evidenceAlt: "دليل",
  },

  status: {
    dirty: "بحاجة إلى تنظيف",
    in_progress: "قيد التنفيذ",
    clean: "نظيفة",
    inspected: "تم التفتيش",
    out_of_service: "خارج الخدمة",
  },

  occupancy: {
    title: "الإشغال",
    aboutToLeave: "على وشك المغادرة",
    checkIn: "الوصول {date}",
    checkOut: "المغادرة {date}",
    checkoutTime: "وقت المغادرة {time}",
    booking: "الحجز {code}",
    nextArrivalToday: "الوصول التالي اليوم",
    fromTime: "من {time}",
    labels: {
      vacant: "شاغرة",
      occupied: "مشغولة",
      departure_today: "تغادر اليوم",
      arrival_today: "تصل اليوم",
      turnover: "مغادرة ووصول اليوم",
    },
  },

  window: {
    windowLabel: "النافذة الزمنية",
    standardSchedule: "جدول قياسي",
    sub: "{label}: المغادرة {checkout} → الوصول {checkin}",
    overdue: "تجاوز موعد الوصول · أعطِ الأولوية لهذا التنظيف",
    untilArrival: "{dur} حتى الوصول",
  },

  tasks: {
    title: "مهام التنظيف",
    // Pluralización (vue-i18n v8 con pipes) — choiceIndex = nº de tareas pendientes
    pendingCount: "{count} مهمة معلّقة | {count} مهام معلّقة",
    newPlaceholder: "أضف مهمة (مثال: تغيير المناشف)",
    priorityTitle: "الأولوية",
    dateTitle: "التاريخ",
    timeTitle: "الوقت (اختياري)",
    assignTitle: "إسناد إلى",
    assignAllOption: "الجميع (التنظيف والصيانة)",
    byRole: "حسب الدور",
    wholeRoleSuffix: "(الدور بأكمله)",
    people: "الأشخاص",
    add: "إضافة",
    adding: "جارٍ الإضافة…",
    loading: "جارٍ تحميل المهام…",
    empty: "لا توجد مهام. أضف الأولى بالأعلى.",
    markPending: "وضع علامة معلّقة",
    markDone: "وضع علامة منجزة",
    priorityDotTitle: "الأولوية {priority}",
    delete: "حذف",
  },

  enc: {
    late: "Overdue",
    title: "Requests for this room",
    what: "One-off things besides the cleaning: restock something, check a fault, a treat for the guest. Whoever goes to the room will see it and tick it off.",
    protocolNote: "The cleaning steps are in the protocol above. This is only for extras.",
    emptyTitle: "No pending requests",
    emptyExamples: "For example: “Replace the bathroom light bulb” or “Leave a welcome bottle of wine”.",
    newBtn: "New request",
    qWhat: "What needs doing?",
    whatPlaceholder: "Write it in your own words…",
    suggestions: "Restock coffee and sugar | Replace a light bulb | Check the air conditioning | Leave extra towels | Check the wifi | Welcome treat",
    qWhen: "When?",
    today: "Today",
    tomorrow: "Tomorrow",
    otherDay: "Another day",
    anyDay: "No date",
    atTime: "At a specific time",
    qWho: "Who does it?",
    whoever: "Whoever cleans",
    isUrgent: "It's urgent",
    urgentHint: "It will stand out and be flagged first.",
    urgent: "Urgent",
    preview: "“{what}” · {when} · {who}",
    cancel: "Cancel",
    save: "Save request",
    showDone: "Show {count} done | Show {count} done",
    hideDone: "Hide done",
    confirmDelete: "Delete the request “{what}”?",
  },

  priority: {
    low: "منخفضة",
    normal: "عادية",
    high: "عالية",
    urgent: "عاجلة",
  },

  roles: {
    limpieza: "التنظيف",
    mantenimiento: "الصيانة",
    propietario: "المالك",
  },

  assignee: {
    assigned: "مُسندة",
    all: "الجميع",
  },
};
